import { filter, map, reduce } from 'lodash';
import { useMemo } from 'react';

import { Math } from 'classes';
import { useCurrencies } from 'hooks';
import { Asset } from 'types';

export const useCalculateAssetBalances = (assets: Asset[] = []) => {
  const { visibleAssetCurrencies } = useCurrencies();
  const balances = useMemo(
    () =>
      map(visibleAssetCurrencies, ({ id }) => ({
        id,
        amount: reduce(
          filter(assets, { assetCurrencyId: id }),
          (acc, asset) => acc.plus(asset.balance, asset.holdBalance),
          new Math(0),
        ).value,
      })),
    [assets, visibleAssetCurrencies],
  );

  return { balances };
};
